/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type DeleteMultipleSkillsInput = {
    ids?: Array<string | null> | null | undefined;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type deleteMultipleSkillsMutationVariables = {
    input: DeleteMultipleSkillsInput;
};
export type deleteMultipleSkillsMutationResponse = {
    readonly deleteMultipleSkills: {
        readonly deletedSkillIds: ReadonlyArray<string | null> | null;
    } | null;
};
export type deleteMultipleSkillsMutation = {
    readonly response: deleteMultipleSkillsMutationResponse;
    readonly variables: deleteMultipleSkillsMutationVariables;
};



/*
mutation deleteMultipleSkillsMutation(
  $input: DeleteMultipleSkillsInput!
) {
  deleteMultipleSkills(input: $input) {
    deletedSkillIds
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteMultipleSkillsInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteMultipleSkillsPayload",
    "kind": "LinkedField",
    "name": "deleteMultipleSkills",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedSkillIds",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deleteMultipleSkillsMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "deleteMultipleSkillsMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "deleteMultipleSkillsMutation",
    "operationKind": "mutation",
    "text": "mutation deleteMultipleSkillsMutation(\n  $input: DeleteMultipleSkillsInput!\n) {\n  deleteMultipleSkills(input: $input) {\n    deletedSkillIds\n  }\n}\n"
  }
};
})();
(node as any).hash = '52f90120611f906e913f49716969e21a';
export default node;
